import { Component, OnInit, SimpleChanges, Input } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../../core/auth/auth.service';
import { UserService } from '../../../../core/user.service';
import * as Chart from "chart.js";
import {MatDialog, MatDialogConfig} from "@angular/material";
import { AnalyticsModalComponent } from '../../../../_models/analytics-modal/analytics-modal.component';

@Component({
  selector: 'app-cqmns-ga-pageviews',
  templateUrl: './cqmns-ga-pageviews.component.html',
  styleUrls: ['./cqmns-ga-pageviews.component.css']
})
export class CqmnsGaPageviewsComponent implements OnInit {

  @Input() viewId: any;
  valueOs: any;
  durationOs: any;
  selectedSource = ''; 
  projects: any;
  projectId: any;
  gadatausers: any;
  hostUrl;
  viewIdApiDevice: any;
  visitedPages: any;
  totalPage: any = [];
  visitedPagesList: any =[];
  userId: any;
  constructor(private http: HttpClient, 
    private route: ActivatedRoute,
     private userService: UserService, private authService: AuthService, 
     private dialog: MatDialog
     ) { }


  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hostUrl=this.userService.getUrl();
    this.userId = localStorage.getItem("userid");

   // this.projectId = this.route.snapshot.params["projectId"];
    this.projectId = localStorage.getItem("projectId");
  }
   ngOnChanges(changes:SimpleChanges){
        this.viewIdApiDevice = changes.viewId.currentValue;
        if (this.visitedPagesList) {
          this.visitedPagesList = [];
        }
        if(this.viewIdApiDevice){
        this. getVisitedPage();
        }

      } 
    getVisitedPage(){
      this.http.get(encodeURI(this.hostUrl+'/api/issue/mostVisitedPageGoogleAnalytics/' + this.projectId + "/7/" +  this.viewIdApiDevice))
      .subscribe(data => {
        this.visitedPages = data;
        this.totalPage = this.visitedPages[0].totalPageViews;
        for (let i = 1; i < this.visitedPages.length; i++) {
         this.visitedPagesList.push(this.visitedPages[i]);
       }
      });
    }
    onchangeOS(valueOs) {
      this.valueOs = valueOs;
      if (this.valueOs === "val07") {
        console.log('val7')
        this.durationOs = '7'
      }
         else if(this.valueOs === "val28")
        {
          console.log('val28')
          this.durationOs = '28'
        }else if(this.valueOs === "val90"){
          console.log('val90')
          this.durationOs = '90'
        }
  
        this.http.get(encodeURI(this.hostUrl+'/api/issue/mostVisitedPageGoogleAnalytics/' + this.projectId + '/' + this.durationOs + "/" +  this.viewIdApiDevice))
      .subscribe(data => {
        this.visitedPages = data;
        this.totalPage = this.visitedPages[0].totalPageViews;
        if (this.visitedPagesList) {
          this.visitedPagesList = [];
        }
        for (let i = 1; i < this.visitedPages.length; i++) {
         this.visitedPagesList.push(this.visitedPages[i]);
       }
      });
      }
    
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-analytics/cqmns-ga-pageviews/cqmns-ga-pageviews.component.ts